import { useState } from 'react';

/**
 * Hook para detectar inactividad y hacer logout automático
 * DESACTIVADO - Sesión ilimitada sin logout automático por inactividad
 * El token JWT sigue expirando en 24 horas por seguridad
 */
const useInactivityLogout = () => {
  const [showWarning] = useState(false);

  const handleStayConnected = () => {
    // No hace nada - logout por inactividad desactivado
  };

  // Retorna valores pero nunca muestra warning ni hace logout
  return { showWarning, handleStayConnected };
};

export default useInactivityLogout;
